import { render, staticRenderFns } from "./mainContentVideoConfs.vue?vue&type=template&id=959def0a&scoped=true&lang=pug&"
import script from "./mainContentVideoConfs.vue?vue&type=script&lang=js&"
export * from "./mainContentVideoConfs.vue?vue&type=script&lang=js&"
import style0 from "./mainContentVideoConfs.vue?vue&type=style&index=0&id=959def0a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959def0a",
  null
  
)

export default component.exports